import { useRef } from 'react';
var uniqueId = 0;
var getUniqueId = function () { return uniqueId++; };
export function useComponentInstanceId(prefix) {
    var idRef = useRef(null);
    if (idRef.current === null) {
        idRef.current = prefix + getUniqueId();
    }
    return idRef.current.toString();
}
//# sourceMappingURL=useComponetInstanceId.js.map